/* eslint-disable @typescript-eslint/member-delimiter-style */
import React, { FC, ReactElement, useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { ListItem, ListItemText, Divider } from '@material-ui/core'
import { inject, observer } from 'mobx-react'
import MasterTemplates from './Templates'
import { Prospects as ProspectsStore } from '../../../stores/prospects'
import { Settings as SettingsStore } from '../../../stores/settings'
import Spinner from '../../../components/Spinner'
import './styles.scss'

interface Props extends RouteComponentProps {
  prospects?: ProspectsStore
  settings?: SettingsStore
}

const Templates: FC<Props> = props => {
  const [currentType, setCurrentType] = useState('Rev-Up')
  const { prospects, match, history, location } = props
  const maneuvers = ['Rev-Up', 'Engaged', 'Re-Engage']
  const handleManeuverChange = (maneuver: string): void => {
    setCurrentType(maneuver)
  }

  let content: ReactElement | null = null

  content = prospects?.isLoading ? (
    <div className="touches w-100">
      <Spinner />
    </div>
  ) : (
    <div className="touches w-100 p-2 overflow-auto">
      <Divider />
      <div className="modal_section">
        {maneuvers.map(maneuver => (
          <ListItem
            button
            className={`mav-modal-title ${currentType === maneuver ? 'active' : ''}`}
            key={maneuver}
            onClick={(): void => handleManeuverChange(maneuver)}
          >
            <ListItemText primary={maneuver} />
          </ListItem>
        ))}
      </div>
      <Divider />
      <MasterTemplates {...{ prospects, history, match, location, currentType }} />
    </div>
  )

  return content
}

export default inject('settings')(observer(Templates))
